export default {
  environment: "production",
  apiUrl: "https://lair-api.zobaze.com",
  ejmalyApiUrl: "https://internal-api.ejmaly.com",
  debugMode: false,
  logoWmUrl: "",
  logoUrl: "",
  portalName: "Ejmaly",
  brandAppName: "Zobaze Partner Portal",
  ejmalyAppName: "Ejmaly Management",
  brandAppLogo: "https://zobaze.com/assets/img/logo/zobaze%20logo@2x.png",
  ejmalyAppLogo: "https://firebasestorage.googleapis.com/v0/b/z-partner.appspot.com/o/w%2FnpHcOKGvfrymnVrdrh0k%2Fbrand%2Flogo%2Fwm.png?alt=media&token=d8dd586b-a98d-4026-878d-5be5cc4fe9c3",
  firebaseConfig: {
    apiKey: "AIzaSyA1BE75nCrS-ETGzXcd-4TCgEdtFBYELkM",
    authDomain: "z-partner.firebaseapp.com",
    projectId: "z-partner",
    storageBucket: "z-partner.appspot.com",
    messagingSenderId: "162265391893",
    appId: "1:162265391893:web:32f7155d1215c18d237f1c",
    measurementId: "G-DD207V1MZJ"
  }
};
